// Simple "no access" panel shown when a user lacks canView for a module/section.

import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function NoAccess({ message }) {
  return (
    <Card>
      <MDBox p={5} display="flex" flexDirection="column" alignItems="center" textAlign="center">
        <Icon color="secondary" sx={{ fontSize: "3rem", mb: 1 }}>
          lock
        </Icon>
        <MDTypography variant="h6" color="text">
          {message}
        </MDTypography>
      </MDBox>
    </Card>
  );
}

NoAccess.defaultProps = {
  message: "You do not have permission to view this section.",
};

NoAccess.propTypes = {
  message: PropTypes.string,
};

export default NoAccess;
